import React from 'react';
import { Table, Button, Spin, Alert } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './PracticeTestAttemptsComponent.scss';

const PracticeTestAttemptsComponent = ({
  testAttempts,
  loading,
  error,
  onViewResults,
  testTitle,
}) => {
  const { t } = useTranslation('practice_tests');
  const history = useHistory();

  const handleBack = () => {
    history.push('/practices-test');
  };

  const columns = [
    {
      title: t('practice_tests.test_attempts.table.test'),
      dataIndex: 'test',
      key: 'test',
      width: '30%',
    },
    {
      title: t('practice_tests.test_attempts.table.time'),
      dataIndex: 'time',
      key: 'time',
      width: '20%',
    },
    {
      title: t('practice_tests.test_attempts.table.result'),
      dataIndex: 'result',
      key: 'result',
      width: '25%',
    },
    {
      title: t('practice_tests.test_attempts.table.score'),
      dataIndex: 'score',
      key: 'score',
      width: '10%',
    },
    {
      title: t('practice_tests.test_attempts.table.action'),
      key: 'action',
      width: '15%',
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() => onViewResults(record.id)}
          className={styles['view-results-button']}
        >
          {t('practice_tests.test_attempts.view_results')}
        </Button>
      ),
    },
  ];

  if (loading) {
    return (
      <div className={styles['loading-container']}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles['error-container']}>
        <Alert
          message="Error"
          description={t('practice_tests.error.load_attempts')}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className={styles['test-attempts-container']}>
      <div className={styles['header']}>
        <div
          className={styles['back-link']}
          onClick={handleBack}
        >
          <ArrowLeftOutlined className={styles['back-icon']} />
          <span className={styles['back-text']}>{t('practice_tests.test_attempts.back')}</span>
        </div>
        <h1 className={styles['title']}>
          {t('practice_tests.test_attempts.title', { testTitle })}
        </h1>
      </div>

      <div className={styles['table-container']}>
        <Table
          columns={columns}
          dataSource={testAttempts}
          rowKey="id"
          bordered={false}
          pagination={false}
          className={styles['test-attempts-table']}
        />
      </div>
    </div>
  );
};

export default PracticeTestAttemptsComponent;
